import DATA from './ramessesi.json';

export default DATA;


import TOUR_DATA from './tour_ramessesi.json';
export { TOUR_DATA };

